angular.module('impactx.product').controller('GalleryCtrl', [
    '$scope',
    'ProductImageGalleryService',
    '$timeout',
    GalleryController
]);

function GalleryController($scope, ProductImageGalleryService, $timeout) {
    var self = this;

    self.$onInit = function () {
        ProductImageGalleryService.imageExists(self.mainImage).then(
            function () {
                $scope.imageNotAvailable = false;
            },
            function () {
                $scope.imageNotAvailable = true;
            }
        );
    }

    self.selectMain = function (newMainImage) {
        self.hasChanged = true;
        $timeout(function () {
            self.hasChanged = false;
        });
        self.mainImage = newMainImage;
    };

    self.openImageGallery = function (event, product) {
        if (event) {
            event.stopPropagation();
        }

        if (product) {
            ProductImageGalleryService.openGallery(event, product);
        }
    }
}